import { getCMSHost } from '@utils/api-helper/host';

const DEFAULT_LOCAL_CMS_HOST = 'http://localhost:1337';

const resolveUpscCmsAssetUrl = (url?: string | null): string => {
  if (!url) return '';

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  const cmsHost = (getCMSHost() || DEFAULT_LOCAL_CMS_HOST).replace(/\/$/, '');
  return `${cmsHost}${url}`;
};

export default resolveUpscCmsAssetUrl;
